import * as React from "react";
import {Box} from "@mui/material";
import {DragOverlay, useDndContext} from "@dnd-kit/core";
import {styles} from "./LeadPipelineStyles";
import LeadPipelineCardDetails from "./LeadPipelineCardDetails";

export default function LeadPipelineDraggedCard({showsCommercialChannel}) {
    const style = styles();
    const {active} = useDndContext();

    return (
        <DragOverlay dropAnimation={null}>
            {active && (
                <Box sx={[style.card, style.cardToneOfStage(active.data.current.stage), style.cardBeingDragged]}>
                    <LeadPipelineCardDetails lead={active.data.current.lead} stage={active.data.current.stage} showsCommercialChannel={showsCommercialChannel}/>
                </Box>
            )}
        </DragOverlay>
    );
}
